// extracted by mini-css-extract-plugin
export default {"layout":"L5gOO","inner":"H1zg1"};